import { useState, useEffect } from "react";
import { IoMenu } from "react-icons/io5";
import AsideMenu from "./Aside";

const Layout = ({ children }) => {
  const [state, setState] = useState({
    isMobile: window.innerWidth < 768,
    showAside: false
  })

  const { isMobile, showAside } = state;

  useEffect(() => {
    // to check if the user is using our application on an mobile device or not
    const getDWidth = () => {
      const isMobile = window.innerWidth < 768;
      setState(prev => ({...prev, isMobile, showAside: isMobile ? false : showAside }));
    }
    window.addEventListener("resize", getDWidth);
    return () => window.removeEventListener('resize', getDWidth);
  }, [window.innerWidth])
  
  return (
    <div className="layout">
      {isMobile ? <div className={`mi-mobile-gear ${showAside ? "open" : ""}`} onClick={() => setState(prev => ({...prev, showAside: !showAside }))}>
        <IoMenu size={20} />
      </div> : null}
        <AsideMenu showMenu={isMobile ? showAside ? true : false : true}/>
      <main style={{width: isMobile ? "100%" : "calc(100% - 280px)", marginLeft: isMobile ? showAside ? "280px" : "0px" : "280px" }}>
        {children}
      </main>
    </div>
  );
}

export default Layout;